import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BarrierefreiheitService} from '../../services/barrierefreiheit.service';
import {environment} from '../../../../environments/environment';
import barriereFreiheitConfig from '../../configs/barrierefreiheit.config.json';
import {DbReaderService} from '../../../../services/db-reader/db-reader.service';

@Component({
  selector: 'barrierefreiheitEinstellungen',
  templateUrl: './barrierefreiheitEinstellungen.component.html',
  styleUrls: ['./barrierefreiheitEinstellungen.component.css'],
})

export class BarrierefreiheitEinstellungenComponent implements OnInit {

  public formGroup: FormGroup
  public textGroesse
  public barriereConfig = barriereFreiheitConfig
  public aktuelleEinstellungen

  constructor(
    public barriereFreiehitService: BarrierefreiheitService,
    public dbReader: DbReaderService,
  ) { }

  ngOnInit() {
    this.dbReader.get('barrierefreiheit', 'Options').subscribe(barriereFreiheit => {
      this.barriereFreiehitService.setzeNeuesForm(barriereFreiheit)
      this.formGroup = this.barriereFreiehitService.barriereForm
      this.pruefeVeraenderung(this.formGroup.value)
      this.aktuelleEinstellungen = barriereFreiheit
      this.barriereFreiehitService.neuesForm.subscribe((result) => {
        this.setzeVeraenderung(result)
        this.aktuelleEinstellungen = result
      })
    })
  }

  public updateForm(value){
    this.setzeVeraenderung(value)
    this.barriereFreiehitService.barriereForm.patchValue(value)
  }

  public pruefeVeraenderung(liste){
    for (let item in liste){
      if (liste[item] !== this.barriereConfig[item]){
        this[item] = 'aktiv'
      }
    }
  }

  public setzeVeraenderung(aktuelleConfig){
    for (let item in aktuelleConfig){
      if (aktuelleConfig[item] !== this.aktuelleEinstellungen[item]){
        this[item] = 'neu'
      }else{
        if (aktuelleConfig[item] !== this.barriereConfig[item]){
          this[item] = 'aktiv'
        }
      }
    }
  }

  protected readonly environment = environment;
}
